
export const DateTimeFormat = 'DD/MM/YYYY - HH:mm';
export const DateTimeShortFormat = 'DD/MM/YY HH:mm';
export const DateFormat = 'DD/MM/YYYY';
export const FILE_25MB = 25214400;
export const URL_BASE = 'https://scp.brasilcidadao.gov.br/scp/authorize';
export const URL_CIDADAO = 'https://cartaosusdigital.saude.gov.br/';
export const HOST_EHR_PROD = 'https://ehr-search-gateway.saude.gov.br';
export const HOST_EHR_HMG = 'https://ehr-services.hmg.saude.gov.br';
export const HOST_EHR = HOST_EHR_PROD;
export const EHR_SERVICE = 'https://ehr-search-gateway.saude.gov.br';

export const ORIGIN = 'PROSUS';

export const URL_MEDICAMENTOS = 'https://cartaosusdigital.saude.gov.br/csusdigifarmpop/rest/medicamentosdispensados/profissional';
export const URL_MEDICAMENTOS_CID = 'https://cartaosusdigital.saude.gov.br/csusdigifarmpop/rest/medicamentosdispensados';
export const URL_CLIENT_HMG = 'https://prosus-hmg.saude.gov.br/login';
export const NEW_CLIENT_ID = 'prosus.saude.gov.br';
export const NEW_SECRET_PROD = 'AIoMXpP-u8MUXVNmYC83-8FQ8edDKgSyb_7ADylVVzv5q6n7xChfoDvvU0b7P_T2q1PhPygngfzRXRHhe4PWgcQ';
export const URL_NEW_BASE_PROD = 'https://sso.acesso.gov.br/authorize';
export const NEW_SCOPE = 'openid+email+phone+profile+govbr_empresa+govbr_confiabilidades';
export const URL_NEW_LOGIN_SCP_PROD = 'https://sso.acesso.gov.br';
export const URL_NEW_LOGIN_SCP_PROD_API = 'https://api.acesso.gov.br';
export const REDIRECT_NEW_URI_DEV = 'https://conectesus-profissional.saude.gov.br/login&nonce=3ed8657fd74c&state=ZGV2';
export const REDIRECT_NEW_URI_HMG = 'https://conectesus-profissional.saude.gov.br/login&nonce=3ed8657fd74c&state=aG1n';
export const REDIRECT_NEW_URI_PROD = 'https://susdigital-profissional.saude.gov.br/login&nonce=3ed8657fd74c&state=358578ce6728b';
export const REDIRECT_URI = REDIRECT_NEW_URI_PROD;
export const URL_BROWSER_NEW_LOGIN_PROD = URL_NEW_BASE_PROD + '?response_type=code&client_id=' + NEW_CLIENT_ID + '&scope=' +
    NEW_SCOPE + '&redirect_uri=' + REDIRECT_URI;
export const URL_CADASTRO = 'https://cadastro.saude.gov.br/cartaosus';
export const URL_PROXY_LOGIN_SCP = 'https://govbr-proxy.saude.gov.br/api';
export const URL_PROXY_LOGIN_SCP_OLD = 'https://cartaosusdigital.saude.gov.br/auth-govbr';

export const HOST_URL_BFF = 'https://ehr-services-bff.saude.gov.br';
export const HOST_URL_BFF_DEV = 'https://ehr-services-bff.dev.saude.gov.br';
export const HOST_URL_BFF_HMG = 'https://ehr-services-bff.hmg.saude.gov.br';
export const URL_BFF = HOST_URL_BFF;
export const URL_CIDADAO_REGISTROS = 'https://cartaosusdigital.saude.gov.br/csusdigimyinfo/';

export const URL_SNS_SEND = 'https://conectesus-sns.saude.gov.br'
export const URL_SNS_HMG = 'https://conectesus-sns.saude.gov.br/api/prosus_hmg'
export const URL_SNS_PROD = 'https://conectesus-sns.saude.gov.br/api/prosus'
export const URL_SNS = URL_SNS_PROD;

export const URL_GERENCIADOR_PROD = 'https://gerenciador-superapp-api.saude.gov.br/';
export const URL_GERENCIADOR_HMG = 'https://gerenciador-superapp-api-hmg.saude.gov.br/';
export const URL_GERENCIADOR = URL_GERENCIADOR_PROD;

export const URL_DENGUE_PRD = 'https://manejodengue.saude.gov.br';
export const URL_DENGUE_HMG = 'https://manejodengue-hom.saude.gov.br';
export const URL_DENGUE = URL_DENGUE_PRD;

export const ENV: any = 'PRD';
